<template>
 <div id="container">
   <div id="time">
      <span id="date">{{ month }}月{{ day }}日 ({{dayOfWeek}})</span>
     <span class="time-item" id="hours">{{ hours }}</span> :
     <span class="time-item" id="minutes">{{ minutes }}</span> 
     <span class="time-item" id="seconds">{{ seconds }}</span>
   </div>
 </div>
</template>
<style scoped>
  #date{
    font-size:16px;
  }
  #time{
    font-size: 16px;
  }
  #seconds{
    font-size:0.5em;
  }
</style>
<script>
 const zeroPadding = (num, digit) => {
   return (Array(digit).join("0") + num).slice(-digit)
 }
 export default {
   props: ["location", "diff"], // Timezone
   data() {
     return {
       date: new Date()
     }
   },
   computed: {
     year() {
       return this.date.getFullYear()
     },
     month() {
       return zeroPadding(this.date.getMonth() + 1, 2)
     },
     day() {
       return zeroPadding(this.date.getDate(), 2)
     },
     dayOfWeek(){
       var day_of_week = this.date.getDay()
       var day_of_week_str = [ "日", "月", "火", "水", "木", "金", "土" ][day_of_week] ;
       return day_of_week_str
     },
     hours() {
       return zeroPadding(this.date.getHours(), 2)
     },
     minutes() {
       return zeroPadding(this.date.getMinutes(), 2)
     },
     seconds() {
       return zeroPadding(this.date.getSeconds(), 2)
     },
   },
   mounted() {
     this.setDate()
     setInterval(() => this.setDate(), 1000)
   },
   methods: {
     setDate() {
       this.date = new Date()
       this.date.setHours(this.date.getHours() + this.diff) // Timezone
     },
   },
 }
</script>


// WEBPACK FOOTER //
// src/components/pages/Clock.vue